import { render } from "./acceleration.vue?vue&type=template&id=76d91782&scoped=true"
import script from "./acceleration.vue?vue&type=script&lang=ts"
export * from "./acceleration.vue?vue&type=script&lang=ts"

import "./acceleration.vue?vue&type=style&index=0&id=76d91782&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-76d91782"

export default script